<script>
import { sharedData } from '../../../static/js/vue_specific/sharedData';
export default {
  /**
   * Cart contents is loaded into shared.cart in MainApp.vue
   */
  props: ['cartUrl'],
  data() {
    return {
      shared: sharedData,
    };
  },
};
</script>

<template>
  <li class="cartcomponent">
    <a :href="cartUrl" v-if="shared.cart.length > 0">
      <span class="items">
        {{ shared.cart.length }}
      </span>
      <span aria-hidden="true" class="material-icons">local_mall</span>
      <strong class="sr-only">My courses</strong>
    </a>
  </li>
</template>
